export const BASE_URL = "https://api.drxasia.com";

export const DROPDOWN_STATUS_OPTIONS = [
  {
    label: "All",
    value: 0,
  },
  {
    label: "Listed",
    value: 1,
  },
  {
    label: "Unlisted",
    value: 2,
  },
];

export const DROPDOWN_STATUS_PRODUCT_OPTIONS = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Owned",
    value: "owned",
  },
  {
    label: "Transfer",
    value: "transfer",
  },
];

export const DROPDOWN_CATEGORY_PRODUCT_OPTIONS = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Jersey",
    value: "Jersey",
  },
  {
    label: "T Shirt",
    value: "T Shirt",
  },
  {
    label: "Shirt",
    value: "Shirt",
  },
  {
    label: "Polo",
    value: "Polo",
  },
  {
    label: "Polo Tee",
    value: "Polo Tee",
  },
  {
    label: "Pants",
    value: "Pants",
  },
  {
    label: "Socks",
    value: "Socks",
  },
  {
    label: "Jacket",
    value: "Jacket",
  },
  {
    label: "Raincoat",
    value: "Raincoat",
  },
  {
    label: "Hoodie",
    value: "Hoodie",
  },
  {
    label: "Cap",
    value: "Cap",
  },
  {
    label: "Bag",
    value: "Bag",
  },
  {
    label: "Shorts",
    value: "Shorts",
  },
  {
    label: "Shoes",
    value: "Shoes",
  },
  {
    label: "Accessories",
    value: "Accessories",
  },
  {
    label: "Sweater",
    value: "Sweater",
  },
];

export const STATUS_PRODUCT = {
  1: "Listed",
  2: "Unlisted",
};
